import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useLocation } from 'react-router-dom';

const GuaranteePage = () => {
  const { orderId } = useParams();
  const [data, setData] = useState(null);
  const location = useLocation();
  const productId = new URLSearchParams(location.search).get('productId');

  useEffect(() => {
    axios
      .get(`/api/orders/guarantee/${orderId}?productId=${productId}`)
      .then(res => setData(res.data))
      .catch(err => console.error(err));
  }, [orderId, productId]); if (!data) {
    return (
      <div className="max-w-xl mx-auto pt-20 p-6 bg-white shadow-lg text-sm rounded-lg border animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-4 mx-auto"></div>
  
        <div className="flex justify-center mb-6">
          <div className="w-32 h-32 bg-gray-200 rounded"></div>
        </div>
  
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
  
        <div className="h-20 bg-gray-100 rounded mb-6"></div>
  
        <div className="flex justify-center mt-4">
          <div className="w-28 h-28 bg-gray-200 rounded"></div>
        </div>
  
        <div className="mt-6 text-center">
          <div className="w-40 h-10 bg-gray-300 rounded mx-auto"></div>
        </div>
      </div>
    );
  }
  

  return (
    <div className="max-w-xl mx-auto pt-20 p-6 bg-white shadow-lg text-sm rounded-lg border">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A5 portrait; margin: 0; }
          body { margin: 0; }
        }
      `}</style>
  
      <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Product Guarantee Certificate</h2>
  
      {/* Product Image */}
      {data.productFinalImage && (
        <div className="flex justify-center mb-4">
          <a href={`/uploads/${data.productFinalImage}`} target="_blank" rel="noopener noreferrer">
            <img
              src={`/uploads/${data.productFinalImage}`}
              alt="Product"
              className="w-32 h-32 object-cover border rounded hover:scale-105 transition-transform"
            />
          </a>
        </div>
      )}
  
      <div className="grid grid-cols-2 gap-4 text-gray-700 mb-6">
        <div>
          <p><strong>Order ID:</strong> {data.orderId}</p>
          <p><strong>Customer:</strong> {data.customerName}</p>
          <p><strong>Phone:</strong> {data.phoneNumber}</p>
        </div>
        <div>
          <p><strong>Product ID:</strong> {data.productId}</p>
          <p><strong>Product:</strong> {data.modelName} <span className="text-yellow-600">(21K)</span></p>
          <p><strong>Weight:</strong> {data.finalWeight ? `${data.finalWeight} g` : 'N/A'}</p>
          <p><strong>Price:</strong> {typeof data.finalPrice === 'number' ? `$${data.finalPrice.toFixed(2)}` : 'N/A'}</p>
        </div>
      </div>
  
      {/* Guarantee Status */}
      <div className="bg-gray-100 border rounded p-4 mb-6 text-center">
        <h3 className="text-sm font-medium mb-2 text-gray-700">Guarantee Validity</h3>
        <p><strong>Valid Until:</strong> {data.guaranteeExpiration ? new Date(data.guaranteeExpiration).toLocaleDateString() : 'N/A'}</p>
        <p><strong>Remaining:</strong> {typeof data.guaranteeValidDays === 'number' ? `${data.guaranteeValidDays} days` : 'N/A'}</p>
      </div>
  
      {/* QR Code */}
      <div className="text-center mt-6 mb-4">
        <img src={data.qrCode} alt="QR Code" className="mx-auto" style={{ maxWidth: '140px' }} />
        <p className="text-xs mt-2 text-gray-500">Scan to verify online</p>
      </div>
  
      <div className="text-center mt-6">
        <button onClick={() => window.print()} className="no-print bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">
          Print Guarantee Card
        </button>
      </div>
    </div>
  );
  
};

export default GuaranteePage;
